import React from 'react';
import {
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
  Tooltip,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigation } from './NavigationContext';

const MobileDrawerToggle: React.FC = () => {
  const theme = useTheme();
  const { toggleSidebar } = useNavigation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!isMobile) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: 16,
        zIndex: theme.zIndex.drawer + 2,
      }}
    >
      <Tooltip title="メニューを開く">
        <IconButton
          onClick={toggleSidebar}
          sx={{
            backgroundColor: theme.palette.background.paper,
            boxShadow: 2,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <MenuIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default MobileDrawerToggle;